module.exports = __webpack_public_path__ + "static/brownie-bg-3-9eebebe18e11c67d89e4161c04193688.jpg";